import { IconName } from '@fortawesome/fontawesome-svg-core';
import { WorldElements } from 'react-give-me-map';

export function getIconForTool(elementType: WorldElements): IconName {
    if (elementType === 'pin') {
        return 'thumbtack';
    } else if (elementType === 'text') {
        return 'font';
    } else if (elementType === 'v2/text') {
        return 'font';
    } else if (elementType === 'image') {
        return 'image-polaroid';
    } else if (elementType === 'draw') {
        return 'paint-brush';
    } else if (elementType === 'polygon') {
        return 'draw-polygon';
    } else if (elementType === 'direction') {
        return 'route';
    } else if (elementType === 'youtube') {
        return 'video';
    } else if (elementType === 'link') {
        return 'link';
    } else if (elementType === 'route') {
        return 'road';
    } else if (elementType === 'v2/route') {
        return 'road';
    } else if (elementType === 'react') {
        return 'code';
    } else if (elementType === 'v2/line') {
        return 'pipe';
    } else if (elementType === 'v2/polygon') {
        return 'draw-polygon';
    } else if (elementType === 'v2/icon') {
        return 'location-dot';
    } else if (elementType === 'v2/wall') {
        return 'block-brick';
    } else if (elementType === 'v2/image') {
        return 'image-polaroid';
    } else if (elementType === 'indoor_stand') {
        return 'person-shelter';
    } else if (elementType === 'v2/variant_icon') {
        return 'location-dot';
    }
}
